module.exports = __webpack_public_path__ + "b666745bf175ed72c1c93f15b84bbb38.png";